export default Backbone.View.extend({
  initialize(options) {
    this.fieldName = options.fieldName;
    const bindings = {
      input: this.fieldName,
    };

    this.stickit(this.model, bindings);
    this.$('.js-search-advanced-filter-checkbox-popover').popover();
    this.configureSubfilters();
  },

  configureSubfilters() {
    const self = this;
    const subfilters = this.$el.attr('data-subfilters') || null;

    if (!subfilters) {
      return;
    }

    this.subfilters = $.parseJSON(subfilters);

    _.each(this.subfilters, fieldName => {
      self.listenTo(self.model, `change:${fieldName}`, _.bind(self.subfilterChange, self));
    });

    this.listenTo(this.model, `change:${this.fieldName}`, _.bind(this.valueChanged, this));
  },

  subfilterChange(model, value) {
    const self = this;
    if (value) {
      // Check to see if all of the subfilters are true
      const allChecked = _.all(this.subfilters, fieldName => self.model.get(fieldName));
      if (allChecked) {
        this.model.set(this.fieldName, true);
      }
    } else {
      // If a subfilter is unchecked, and this filter is checked,
      // then we should uncheck this filter
      if (this.model.get(this.fieldName)) {
        this.model.set(this.fieldName, false);
      }
    }
  },

  valueChanged(model, value) {
    const self = this;
    if (value) {
      _.each(this.subfilters, fieldName => {
        self.model.set(fieldName, true);
      });
    } else {
      const allChecked = _.all(this.subfilters, fieldName => self.model.get(fieldName));
      if (allChecked) {
        _.each(this.subfilters, fieldName => {
          self.model.set(fieldName, false);
        });
      }
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/advanced_filter_checkbox.js